import React from "react";
import LeftMenuItems from "../LeftMenuItems";
import { FaCompressAlt, FaExpandAlt, FaHeart } from "react-icons/fa";
import "./Sidebar.css";

const Sidebar = ({ menu, onSelect }) => {
  const [collapsed, setCollapsed] = React.useState(false);

  return (
    <aside
      className={`sidebar bg-white border-end d-flex flex-column ${collapsed ? "sidebar-collapsed" : "sidebar-expanded"}`}
    >
      <div className="p-3 border-bottom d-flex align-items-center sidebar-menu-header">
        {!collapsed && <h5 className="mb-0 sidebar-title">Navigation</h5>}
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="btn btn-sm sidebar-toggle-btn ms-auto"
          title={collapsed ? "Expand" : "Collapse"}
        >
          {collapsed ? <FaExpandAlt size={14} /> : <FaCompressAlt size={14} />}
        </button>
      </div>
      <div className="flex-grow-1 sidebar-scroll">
        <div className={collapsed ? "p-1" : "p-3"}>
          <LeftMenuItems
            menu={menu}
            onSelect={onSelect}
            collapsed={collapsed}
          />
        </div>
      </div>
      {!collapsed && <div className="p-2 border-top d-flex align-items-center sidebar-menu-footer">Made with&nbsp;<FaHeart color="red" />&nbsp;by&nbsp;<a href="https://www.sidtechtalks.in" target="_blank" rel="noopener noreferrer"> SidTechTalks</a></div>}
    </aside>
  );
};

export default Sidebar;
